













































import Vue from "vue";

export default Vue.extend({
  name: "QuickEntrySlide",
  props: {
    image: {
      type: String,
      required: false,
    },
    imageRatios: {
      type: String,
      required: false,
    },
    name: {
      type: String,
      required: true,
    },
    copy: {
      type: String,
      required: false,
    },
    slideId: {
      type: String,
      required: true,
    },
    clickFunction: {
      type: Function,
      required: true,
    },
    fixedHeight: {
      type: Boolean,
      required: false,
    },
  },
});
